import { CreateTransactionRow } from '@willow/types-iso';

import { formatResponseForFlatfile } from '../../shared/formatResponse';
import { makeValidator } from '../../shared/makeValidator';

export const validateCreateTransaction = makeValidator({
  FieldParser: CreateTransactionRow,
});

export const validateCreateTransactionForFlatfile = (data: any) => {
  const parsed = validateCreateTransaction(data);
  const formatted = formatResponseForFlatfile(parsed, 'loanId');

  return formatted;
};
